/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';

import { Button, Select } from '@/ui/index';

import styles from './Filters.module.scss';

const defaultCityValue = {
  name: 'All',
  value: 'all',
};
const defaultOfficeValue = {
  name: 'All',
  value: 0,
};

const Filters = ({ className = '', setTab, tab, cities, offices }) => {
  const { t, lang } = useTranslation();
  const router = useRouter();
  const cityParam = router.query?.city;
  const officeTypeParam = router.query?.officeType;
  const mappedData = (data) => {
    const mapped = data?.map((x) => ({
      name: x.name,
      value: x.id,
    }));
    return mapped;
  };
  const [city, setCity] = useState(defaultCityValue);
  const [officeType, setOfficeType] = useState(defaultOfficeValue);
  const cityHandler = (city) => {
    const { ...routerQuery } = router.query;
    setCity(city);
    router.push(
      {
        pathname: router.pathname,
        query: {
          ...routerQuery,
          city: city?.value,
        },
      },
      undefined,
      { shallow: true },
    );
  };

  const officeTypeHandler = (office) => {
    const { ...routerQuery } = router.query;
    setOfficeType(city);
    router.push(
      {
        pathname: router.pathname,
        query: {
          ...routerQuery,
          officeType: office?.value,
        },
      },
      undefined,
      { shallow: true },
    );
  };

  useEffect(() => {
    if (!router.isReady) return;
    if (cityParam) {
      const value = mappedData(cities).find(
        (item) => String(item.value) === String(cityParam),
      );

      if (value) {
        setCity(value);
      } else {
        setCity(defaultCityValue);
      }
    }
    if (officeTypeParam) {
      const value = mappedData(offices).find(
        (item) => String(item.value) === String(officeTypeParam),
      );
      if (value) {
        setOfficeType(value);
      } else {
        setOfficeType(defaultOfficeValue);
      }
    }
  }, [router.isReady, officeTypeParam, cityParam, lang]);

  return (
    <div
      className={`${styles.wrap} ${className || ''} flex-c-c`}
      itemScope
      itemType='https://schema.org/Filter'
    >
      <div className={styles.filtersBlock}>
        {/* <div
          className={`${styles.block} ${styles.action} flex-c-c`}
          onClick={() => gps()}
        >
          <Gps />
        </div> */}
        <div className={styles.block}>
          <div className={`${styles.filter} flex-c`}>
            <div className={`${styles.buttons} flex-c`}>
              <Button
                onClick={() => setTab('map')}
                className={`${styles.button} ${
                  tab === 'map' ? styles.active : ''
                }`}
                data-testid='office-map'
              >
                {t('common:map')}
              </Button>
              <Button
                onClick={() => setTab('list')}
                className={`${styles.button} ${
                  tab === 'list' ? styles.active : ''
                }`}
                data-testid='office-list'
              >
                {t('common:list')}
              </Button>
            </div>
            <div className={styles.selects}>
              <Select
                value={city}
                data={mappedData(cities)}
                label={t('common:city')}
                className={styles.select}
                onChange={cityHandler}
                data-testid={'filter-city-input'}
              />
              <Select
                value={officeType}
                data={mappedData(offices)}
                label={t('common:offices')}
                className={styles.select}
                onChange={officeTypeHandler}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filters;
